import { EditInvoiceMainData } from '../editInvoice/editInvoiceMainData';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography, Grid } from '@mui/material';
import { FormatDate } from '../../../utils/formatDate';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import Iconify from '../../Iconify';
import '../../../css/invoices/invoiceMainData.css';

const InvoiceMainData = () => {

    const navigate = useNavigate()
    const invoiceDetailsData = useSelector((state) => state.InvoiceDetailsData);
    const hasInvoiceUpdatePermission = useHasPermission('facture_update');

    const [openEditInvoiceMainData, setOpenEditInvoiceMainData] = useState(false);

    return (
        <Box className='invoiceData_box'>
            <Box className='invoiceData_edit_box'>
                <Typography className='invoiceData_title'>Informations générales de la facture</Typography>
                {hasInvoiceUpdatePermission && <Iconify className='invoiceData_edit_icon' icon={"ic:outline-edit"} onClick={() => setOpenEditInvoiceMainData(true)} />}
            </Box>
            <Grid container spacing={2} >
                <Grid item xs={12} sm={6} md={4} className='invoiceData_icon_title_response_box'>
                    <Iconify icon={"material-symbols:date-range-outline-rounded"} width="32px" />
                    <Box className='invoiceData_response_box'>
                        <Typography className='invoiceData_text_label'>Date:</Typography>
                        <Typography className='invoiceData_text_value'>{FormatDate(invoiceDetailsData?.date)}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className='invoiceData_icon_title_response_box'>
                    <Iconify icon={"fluent:radio-button-16-filled"} width="32px" />
                    <Box className='invoiceData_response_box'>
                        <Typography className='invoiceData_text_label'>Type de facture :</Typography>
                        <Typography className='invoiceData_text_value'>{invoiceDetailsData?.contract?.id ? `Associée à un contrat` : `Sans contrat`}</Typography>
                    </Box>
                </Grid>
                {invoiceDetailsData?.contract?.id && (
                    <Grid item xs={12} sm={6} md={4} className='invoiceData_icon_title_response_box'>
                        <Iconify icon={"pepicons-pencil:file"} width="32px" />
                        <Box className='invoiceData_response_box'>
                            <Typography className='invoiceData_text_label'>Contrat concerné :</Typography>
                            <Typography className='invoiceData_contract_info'>
                                {invoiceDetailsData?.contract?.title}
                                <Iconify
                                    className='invoiceData_arrow_icon'
                                    icon={"ri:arrow-right-up-line"}
                                    onClick={() => navigate(`/dashboard/contract/contract_details/${invoiceDetailsData?.contract?.id}`)}
                                />
                            </Typography>
                        </Box>
                    </Grid>
                )}
                <Grid item xs={12} sm={6} md={4} className='invoiceData_icon_title_response_box'>
                    <Iconify icon={"uil:building"} width="32px" />
                    <Box className='invoiceData_response_box'>
                        <Typography className='invoiceData_text_label'>Entreprise :</Typography>
                        <Typography className='invoiceData_text_value'>{invoiceDetailsData?.company?.name}</Typography>
                    </Box>
                </Grid>
            </Grid>
            {openEditInvoiceMainData &&
                <EditInvoiceMainData
                    openEditInvoiceMainData={openEditInvoiceMainData}
                    setOpenEditInvoiceMainData={setOpenEditInvoiceMainData}
                />
            }
        </Box>

    );
}

export default InvoiceMainData;